module.exports = __webpack_public_path__ + "static/media/CabinetDoorCorner_Before.4f9444f7.jpg";